import { bookingManagementApi } from "./booking-management-api";
import { Convert, CreateNeteraAccountRequest, NeteraAccount } from "@/models/responses";

export interface PasswordChange {
    id: number;
    password: string;
}

export const filingCredentialsApi = bookingManagementApi.injectEndpoints({
    endpoints: (builder) => ({
        getNeteraAccounts: builder.query<NeteraAccount[], void>({
            query: () => ({ url: "admin/netera-accounts" }),
            transformResponse: (response: string) => Convert.toGetNeteraAccountsResponse(JSON.stringify(response)).accounts,
            providesTags: ["NeteraAccounts"],
        }),
        createNeteraAccount: builder.mutation<void, CreateNeteraAccountRequest>({
            query: (account) => ({
                url: "admin/netera-accounts",
                method: "POST",
                body: account,
            }),
            invalidatesTags: (_result, error) => (error ? [] : ["NeteraAccounts"]),
        }),
        changeNeteraAccountPassword: builder.mutation<void, PasswordChange>({
            query: ({ id, password }) => ({
                url: `admin/netera-accounts/${id}/password`,
                method: "PUT",
                body: { password },
            }),
            invalidatesTags: (_result, error) => (error ? [] : ["NeteraAccounts"]),
        }),
        changeStrOwnerPassword: builder.mutation<void, PasswordChange>({
            query: ({ id, password }) => ({
                url: `admin/str-owners/${id}/password`,
                method: "PATCH",
                body: { password },
            }),
        }),
    }),
});

export const {
    useGetNeteraAccountsQuery,
    useCreateNeteraAccountMutation,
    useChangeNeteraAccountPasswordMutation,
    useChangeStrOwnerPasswordMutation,
} = filingCredentialsApi;
